<!-- Current image indicator -->
 @if (currentImageName()) {
  <div class="text-sm text-gray-600 dark:text-gray-400">
    <span>{{ 'image-picker.current' | translate }}: <strong>{{ currentImageName() }}</strong></span>
  </div>
} @else if (!pendingFile()) {
  <div class="text-sm text-gray-400 dark:text-gray-500">{{ 'image-picker.none' | translate }}</div>
}

<!-- Image display: pending preview takes priority over saved image -->
 @if (previewUrl()) {
  <img [src]="previewUrl()!" alt="Preview" class="max-w-xs max-h-48 rounded border object-cover" />
} @else if (currentImageUrl()) {
  <img [src]="currentImageUrl()!" alt="Current image" class="max-w-xs max-h-48 rounded border object-cover" />
}

<!-- Actions -->
<div class="flex gap-2 items-center flex-wrap mt-3">
  <button mat-stroked-button type="button" (click)="fileInput.click()">
    <mat-icon>photo_camera</mat-icon>
    {{ 'image-picker.select' | translate }}
  </button>
  <input #fileInput type="file" accept="image/*" class="hidden" (change)="onFileChange($event)" />
</div>
